// @flow

import { combineReducers } from "redux";
import employeeDetails, { initialState as employeeDetailsInitialState } from "./employee-details";

export const initialState = {
  employeeDetails: employeeDetailsInitialState,
};

export default combineReducers({
  employeeDetails,
});
